module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CopyEventToRegions"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v,
      "disabled": true
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.events), function(event, index) {
    return _c('tr', {
      class: {
        error: _vm.$v.selectedEvents.$each[index] && _vm.$v.selectedEvents.$each[index].$error
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (event.isSelected),
        expression: "event.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(event.isSelected) ? _vm._i(event.isSelected, null) > -1 : (event.isSelected)
      },
      on: {
        "__c": function($event) {
          var $$a = event.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (event.isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (event.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            event.isSelected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(event.region.name) + "\n          ")]), _vm._v(" "), _c('td', [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.selectedEvents.$each[index] && !_vm.$v.selectedEvents.$each[index].eventCode.unique),
        expression: "$v.selectedEvents.$each[index] && !$v.selectedEvents.$each[index].eventCode.unique"
      }]
    }, [_c('small', {
      staticClass: "CopyEventToRegions__error"
    }, [_vm._v("\n                Region already has event with code \"" + _vm._s(event.eventCode) + "\"\n              ")])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.selectedEvents.$each[index] && _vm.$v.selectedEvents.$each[index].discountedProducts.$error),
        expression: "$v.selectedEvents.$each[index] && $v.selectedEvents.$each[index].discountedProducts.$error"
      }]
    }, [_c('small', {
      staticClass: "CopyEventToRegions__error"
    }, [_vm._v("\n                Some of the discounted products already has an overlapping discount or promotion set in this region.\n              ")])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.selectedEvents.$each[index] && _vm.$v.selectedEvents.$each[index].specialPromotions.$error),
        expression: "$v.selectedEvents.$each[index] && $v.selectedEvents.$each[index].specialPromotions.$error"
      }]
    }, [_c('small', {
      staticClass: "CopyEventToRegions__error"
    }, [_vm._v("\n                Some of the special promotions already has an overlapping discount or promotion set in this region.\n              ")])])])])
  }))])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("\n        Copy special price event\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Select the regions you want to copy this event to")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Region")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c693ced0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CopyEventToRegions/CopyEventToRegions.vue
// module id = 1706
// module chunks = 1